<template>
  <div class="da-pi-main">
    <div v-for="(resource, i) in resources" :key="i">
      <div class="da-pi-main-element" v-if="resource.type == 'SIMPLE'">
          <span class="da-pi-main-element-title">{{resource.title}}</span>
          <div class="da-progress-box-simple">
              <progress class="da-progress-value" id="da-progress-domains" :value="resource.current" :max="resource.limit"></progress>
              <span class="da-pi-main-qty">{{resource.right}}</span>
          </div>
      </div>
      <div class="da-pi-main-element" v-else>
          <span class="da-pi-main-element-title">{{resource.title}}</span>
          <progress class="da-progress-value" id="da-progress-box-double" :value="resource.current" :max="resource.limit"></progress>
          <div class="da-pi-main-box-qty">
              <span class="da-pi-main-qty">{{resource.left}}</span>
              <span class="da-pi-main-qty">{{resource.right}}</span>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: "resources-quotas",
    props: ['resources']
  }
</script>

<style scoped lang="scss">
.da-pi-main {
  display: flex;
  flex-direction: column;
  gap: .6rem;
  width: 100%;

  .da-pi-main-element {
    display: flex;
    flex-direction: column;
    gap: .1rem;

    .da-pi-main-element-title {
      color: #717D8D;
      font-size: 14px;
      font-weight: 600;
    }

    .da-progress-box-simple {
      display: grid;
      grid-template-columns: 1fr auto;
      align-items: center;
      gap: .4rem;
    }

    .da-progress-value {
      height: 7px;
      border-radius: 10px;
      display: flex;
      position: relative;
      border-radius: 10px;
      width: 100%;

      &::-webkit-progress-bar {
        border-radius: 10px;
        background-color: #C7D2DC59;
      }

      &::-webkit-progress-value {
        background: linear-gradient(261deg, #20E4B3 66.65%, #1DC4E9 100%);
        border-radius: 10px;
      }
    }

    .da-pi-main-box-qty {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 1rem;
    }

    .da-pi-main-qty {
      color: #4D5D71;
      font-size: 13px;
      font-weight: 600;
    }
  }
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/resources/ResourcesQuotas.vue